import { supabase } from "@/lib/supabase/supabaseClient";
import { ArchiveResponseProps } from ".";

export const archiveResponse = async ({responseId, archived}:ArchiveResponseProps) => await supabase.from("response").update({ archived }).eq('id', responseId).select();